/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as StaffRouteImport } from './routes/_staff'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as ArtworksRouteImport } from './routes/_artworks'
import { Route as ArtworksIndexRouteImport } from './routes/_artworks/index'
import { Route as StaffStaffIndexRouteImport } from './routes/_staff/staff/index'
import { Route as AuthAuthIndexRouteImport } from './routes/_auth/auth/index'
import { Route as AuthAuthTokenEmailTokenRouteImport } from './routes/_auth/auth/token.$email.$token'

const StaffRoute = StaffRouteImport.update({
  id: '/_staff',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const ArtworksRoute = ArtworksRouteImport.update({
  id: '/_artworks',
  getParentRoute: () => rootRouteImport,
} as any)
const ArtworksIndexRoute = ArtworksIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ArtworksRoute,
} as any)
const StaffStaffIndexRoute = StaffStaffIndexRouteImport.update({
  id: '/staff/',
  path: '/staff/',
  getParentRoute: () => StaffRoute,
} as any)
const AuthAuthIndexRoute = AuthAuthIndexRouteImport.update({
  id: '/auth/',
  path: '/auth/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAuthTokenEmailTokenRoute = AuthAuthTokenEmailTokenRouteImport.update({
  id: '/auth/token/$email/$token',
  path: '/auth/token/$email/$token',
  getParentRoute: () => AuthRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof ArtworksIndexRoute
  '/auth': typeof AuthAuthIndexRoute
  '/staff': typeof StaffStaffIndexRoute
  '/auth/token/$email/$token': typeof AuthAuthTokenEmailTokenRoute
}
export interface FileRoutesByTo {
  '/': typeof ArtworksIndexRoute
  '/auth': typeof AuthAuthIndexRoute
  '/staff': typeof StaffStaffIndexRoute
  '/auth/token/$email/$token': typeof AuthAuthTokenEmailTokenRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_artworks': typeof ArtworksRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/_staff': typeof StaffRouteWithChildren
  '/_artworks/': typeof ArtworksIndexRoute
  '/_auth/auth/': typeof AuthAuthIndexRoute
  '/_staff/staff/': typeof StaffStaffIndexRoute
  '/_auth/auth/token/$email/$token': typeof AuthAuthTokenEmailTokenRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/auth' | '/staff' | '/auth/token/$email/$token'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/auth' | '/staff' | '/auth/token/$email/$token'
  id:
    | '__root__'
    | '/_artworks'
    | '/_auth'
    | '/_staff'
    | '/_artworks/'
    | '/_auth/auth/'
    | '/_staff/staff/'
    | '/_auth/auth/token/$email/$token'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  ArtworksRoute: typeof ArtworksRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  StaffRoute: typeof StaffRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_staff': {
      id: '/_staff'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof StaffRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_artworks': {
      id: '/_artworks'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof ArtworksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_artworks/': {
      id: '/_artworks/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof ArtworksIndexRouteImport
      parentRoute: typeof ArtworksRoute
    }
    '/_staff/staff/': {
      id: '/_staff/staff/'
      path: '/staff'
      fullPath: '/staff'
      preLoaderRoute: typeof StaffStaffIndexRouteImport
      parentRoute: typeof StaffRoute
    }
    '/_auth/auth/': {
      id: '/_auth/auth/'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthAuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/auth/token/$email/$token': {
      id: '/_auth/auth/token/$email/$token'
      path: '/auth/token/$email/$token'
      fullPath: '/auth/token/$email/$token'
      preLoaderRoute: typeof AuthAuthTokenEmailTokenRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface ArtworksRouteChildren {
  ArtworksIndexRoute: typeof ArtworksIndexRoute
}

const ArtworksRouteChildren: ArtworksRouteChildren = {
  ArtworksIndexRoute: ArtworksIndexRoute,
}

const ArtworksRouteWithChildren = ArtworksRoute._addFileChildren(
  ArtworksRouteChildren,
)

interface AuthRouteChildren {
  AuthAuthIndexRoute: typeof AuthAuthIndexRoute
  AuthAuthTokenEmailTokenRoute: typeof AuthAuthTokenEmailTokenRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAuthIndexRoute: AuthAuthIndexRoute,
  AuthAuthTokenEmailTokenRoute: AuthAuthTokenEmailTokenRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface StaffRouteChildren {
  StaffStaffIndexRoute: typeof StaffStaffIndexRoute
}

const StaffRouteChildren: StaffRouteChildren = {
  StaffStaffIndexRoute: StaffStaffIndexRoute,
}

const StaffRouteWithChildren = StaffRoute._addFileChildren(StaffRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  ArtworksRoute: ArtworksRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  StaffRoute: StaffRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
